<script>
    import Constantes from "../../Classes/Constantes";
    import { ItemMenus } from "../../Classes/ItemMenus";
    import ItensMenuTela from "../../componentes_basicos/ItensMenuTela.svelte";
 export let background="/img/menu.jfif";
    let itens = [
        new ItemMenus({
            nome: "Assessorias",
            navegarPara: Constantes.tela_assessorias,
            icone: "fas fa-chalkboard-teacher",
            permissao: "",
            SoLogado: false,
        }),
    new ItemMenus({
      nome: "Anamnese",
      navegarPara: Constantes.tela_anamnese,
      icone: "fas fa-notes-medical",
      permissao: "poder_ver_anamnese",
      SoLogado: true,
    }),
        new ItemMenus({
            nome: "Relatórios",
            navegarPara: "/relatorios",
            icone: "fas fa-user",
            permissao: "pode_ver_relatorio",
            SoLogado: true,
        }),
        new ItemMenus({
            nome: "Prescrever treinos",
            navegarPara: Constantes.tela_cadastrar_treino_atleta,
            icone: "fas fa-clipboard-list",
            permissao: "pode_prescrever_treinos",
            SoLogado: false,
        }),
        new ItemMenus({
            nome: "Prescrever treinos com caledario",
            navegarPara: Constantes.tela_cadastrar_treino_atleta3,
            icone: "fas fa-clipboard-list",
            permissao: "pode_prescrever_treinos",
            SoLogado: true,
        }),
       
        new ItemMenus({
            nome: "Criar treino",
            navegarPara: Constantes.tela_exibe_lista_treinos,
            icone: "fas fa-tasks",
            permissao: "pode_criar_treino",
            SoLogado: true,
        }),
        new ItemMenus({
            nome: "Meus atletas",
            navegarPara: Constantes.tela_do_atleta,
            icone: "fas fa-user-friends",
            permissao: "pode_ver_atletas",
            SoLogado: true,
        }),
        new ItemMenus({
            nome: "Meu plano de treino",
            navegarPara: Constantes.tela_exibe_plano_corrida,
            icone: "fa-solid fa-person-running",
            permissao: "pode_ver_treinos",
        }),
         new ItemMenus({
            nome: "Calculadora de Zonas",
            navegarPara: Constantes.tela_calcula_zona,
            icone: "fa fa-calculator",
            permissao:"",
            
        }),
        new ItemMenus({
            nome: "Calculadora de Velocidades/Paces",
            navegarPara: Constantes.tela_calcula_pace,
            icone: "fa fa-chart-line",
            permissao:"",
            
        }),
          new ItemMenus({
            nome: "Meu perfil",
            navegarPara: Constantes.tela_meu_cadastro,
            icone: "fa fa-id-badge",
            permissao:Constantes.pode_ver_meu_cadastro,
            SoLogado: true,
        }),
            new ItemMenus({
            nome: "Sobre",
            navegarPara: Constantes.tela_sobre,
            icone: "fa fa-info-circle",
            permissao:"",
           
        }),
        new ItemMenus({
            nome: "Configurações",
            navegarPara: Constantes.tela_menu_config,
            icone: "fa fa-cog",
            permissao: Constantes.pode_ver_configuracoes,
            SoLogado: true,
        }),
        new ItemMenus({
            nome: "Logout",
            navegarPara: "/",
            icone: "fas fa-lock",
            permissao: "",
            SoLogado: true,
            logout: true,
        }),
        new ItemMenus({
            nome: "Login",
            navegarPara: "/login2",
            icone: "fas fa-lock",
            permissao: "",
            login: true,
        }),
    ];
</script>


    <ItensMenuTela {itens}  {background}/>



